import SidebarComponent from "../../components/Sidebar";
import NavbarComponent from "../../components/Navbar";
import React, { Component } from "react";
import { POST, tokens, baht, total, report_products_invoice, alert } from "../../components/CustomComponent.js";
import "../../assets/css/bootstrap.css";
export default class ReportProductsAndServicesScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      loading: false,

      data: [],
      data_customer: [],

      customer_id: "",
      start_date: "",
      end_date: "",
    };
  }
  async componentDidMount() {}
  GetAll = async () => {
    this.setState({ loading: true });
    if (this.state.start_date === "" && this.state.end_date !== "") {
      alert("warning", "แจ้งเตือน", "กรุณาเลือกวันที่เริ่มต้น");
      this.setState({ loading: false, end_date: "" });
      return;
    }
    let body = {
      customer_id: this.state.customer_id ? Number(this.state.customer_id) : "",
      start_date: this.state.start_date,
      end_date: this.state.end_date,
    };
    let result = await POST(tokens, "v1/report/sale-product-service-invoice/summary/page/0", body);
    if (result && result.status) {
      this.setState({ data: result.data.data });
    }
    this.setState({ loading: false });
  };

  HandlePageChange(pageNumber) {
    this.setState({ page: pageNumber });
    setTimeout(() => {
      this.GetAll();
    }, 10);
  }

  ClearForm() {
    this.setState({
      page: 1,

      customer_id: "",
      start_date: "",
      end_date: "",
      data: [],
    });
  }
  render() {
    return (
      <div className="full bg-contain w-100">
        {this.state.loading && (
          <div className="spinner-container">
            <div className="loading-spinner"></div>
          </div>
        )}
        <div className="menu-container">
          <SidebarComponent />
          <div className="bodyw-100">
            <NavbarComponent page1="หน้าหลัก" page2="รายงานรายละเอียดยอดขาย" />
            <div style={{ height: 60 }}></div>
            <div className="w-100 row mx-0 d-flex align-items-center justify-content-between px-3 mt-3">
              <h3>
                <b>รายงานรายละเอียดยอดขาย</b>
              </h3>
              <div>
                <button
                  type="button"
                  className="btn btn-outline-primary w-100"
                  onClick={() => {
                    if (this.state.data.length === 0) {
                      alert("warning", "แจ้งเตือน", "กรุณาเลือกข้อมูลที่ต้องการออกรายงาน");
                      return;
                    }
                    report_products_invoice(this.state.data, this.state.start_date, this.state.end_date);
                  }}
                >
                  <span className="icon-brand text-18 ">{"\uf6dd"}</span> ออกรายงาน
                </button>
              </div>
            </div>
            <div className="w-100 p-3">
              <div className="card">
                <div className="card-header row d-flex mx-0 px-2 rounded-top-16">
                  <div className="d-flex row mx-0 justify-content-between w-100">
                    <div className="d-flex row mx-0 align-items-center">
                      <input
                        type="date"
                        className="form-control-select wpx-180 mx-2 mb-2 pointer"
                        placeholder="วันที่เริ่มต้น"
                        onChange={(e) => {
                          this.setState({
                            start_date: e.target.value,
                          });
                        }}
                        value={this.state.start_date}
                      ></input>
                      <label className="mx-2 mb-2">ถึง</label>
                      <input
                        type="date"
                        className="form-control-select wpx-180 mx-2 mb-2 pointer"
                        placeholder="วันที่สิ้นสุด"
                        onChange={(e) => {
                          const date_start_date = new Date(this.state.start_date).getTime();
                          const date_end_date = new Date(e.target.value).getTime();

                          if (date_start_date <= date_end_date) {
                            this.setState({ end_date: e.target.value });
                          }
                        }}
                        value={this.state.end_date}
                      ></input>
                      <button
                        type="button"
                        className="btn btn-primary ml-2 mb-1"
                        onClick={() => {
                          this.GetAll();
                        }}
                      >
                        {" "}
                        ค้นหา
                      </button>
                      <button
                        type="button"
                        className="btn btn-outline-primary bg-white mx-2 mb-2 pointer"
                        onClick={() => {
                          this.ClearForm();
                        }}
                      >
                        <span className="icon-brand text-18 pointer">{"\uf2f9"}</span> รีเซ็ท
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body p-0">
                  <div className="table-responsive rounded-16">
                    <table className="table table-striped table-borderless table-sm">
                      <thead>
                        <tr>
                          <th className="text-left">
                            <b>วันที่</b>
                          </th>
                          <th className="text-left">
                            <b>หมายเลข</b>
                          </th>
                          <th className="text-left" style={{ minWidth: 110 }}>
                            <b>ลูกค้า</b>
                          </th>
                          <th className="text-left" style={{ minWidth: 130 }}>
                            <b>สินค้า</b>
                          </th>
                          <th className="text-left" style={{ minWidth: 90 }}>
                            <b>รายละเอียด</b>
                          </th>
                          <th className="text-right" style={{ minWidth: 80 }}>
                            <b>Sales/Price</b>
                          </th>
                          <th className="text-right" style={{ minWidth: 80 }}>
                            <b>ไม้</b>
                          </th>
                          <th className="text-right" style={{ minWidth: 80 }}>
                            <b>หลา</b>
                          </th>
                          <th className="text-right" style={{ minWidth: 80 }}>
                            <b>Amount</b>
                          </th>
                          {/* <th className="text-center">วิธีการชำระเงิน</th> */}
                        </tr>
                      </thead>

                      {((this.state.data && this.state.data.length === 0) || !this.state.data) && (
                        <tbody>
                          <tr>
                            <td colSpan={10} className="text-center table-light">
                              -- ไม่มีข้อมูล --
                            </td>
                          </tr>
                        </tbody>
                      )}
                      {this.state.data &&
                        this.state.data.map((item, index) => (
                          <tbody>
                            <tr
                              key={"dt" + index}
                              className="table-light pointer"
                              onClick={() => {
                                let data = this.state.data;
                                if (data[index].expand) {
                                  data[index].expand = !data[index].expand;
                                } else {
                                  data[index].expand = true;
                                }
                                this.setState({ data: data });
                              }}
                            >
                              <td className="text-left">
                                {item.date}
                                <span className="icon ml-2 text-10">{item.expand ? "\uf077" : "\uf078"}</span>
                              </td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </tr>
                            {item.expand &&
                              item.product_list.map((product, product_index) => (
                                <tr key={"pd" + product_index}>
                                  <td className="text-left"></td>
                                  <td className="text-left">{product.invoice_number}</td>
                                  <td className="text-left">{product.member_name}</td>
                                  <td className="text-left">{product.product_name}</td>
                                  <td className="text-left">{product.order_detail.toString().replaceAll("[", "").replaceAll("]", "").replaceAll(",", ", ")}</td>
                                  <td className="text-right">{baht(product.product_price)}</td>
                                  <td className="text-right">{baht(product.total_wood)}</td>
                                  <td className="text-right">{baht(product.total_yard)}</td>
                                  <td className="text-right">{baht(product.amount)}</td>
                                  {/* <td className="text-center">{product.payment_type === 1 ? "เงินสด" : product.payment_type === 3 ? "โอน" : product.payment_type === 5 ? "เงินสด / โอน" : "-"}</td> */}
                                </tr>
                              ))}
                            {item.expand && (
                              <tr key={index} className="table-light pointer">
                                <td className="text-left">
                                  <b>ยอดรวม</b>
                                </td>
                                <td className="text-left"></td>
                                <td className="text-left"></td>
                                <td className="text-left"></td>
                                <td className="text-left"></td>
                                <td className="text-right wpx-140">
                                  <b>{baht(item.product_price)} บาท</b>
                                </td>
                                <td className="text-right wpx-140">
                                  <b>{item.total_wood} ไม้</b>
                                </td>
                                <td className="text-right wpx-150">
                                  <b>{baht(item.total_yard)} หลา</b>
                                </td>
                                <td className="text-right wpx-150">
                                  <b>{baht(item.amount)} บาท</b>
                                </td>
                                <td className="text-center"></td>
                              </tr>
                            )}
                          </tbody>
                        ))}
                      <tfoot>
                        <td className="text-left wpx-130">
                          <b>ยอดรวมทั้งหมด</b>
                        </td>
                        <td className="text-left"></td>
                        <td className="text-left"></td>
                        <td className="text-left"></td>
                        <td className="text-left"></td>
                        <td className="text-right wpx-140">
                          <b>{baht(total(this.state.data, "product_price"))} บาท</b>
                        </td>
                        <td className="text-right wpx-140">
                          <b>{total(this.state.data, "total_wood")} ไม้</b>
                        </td>
                        <td className="text-right wpx-150">
                          <b>{baht(total(this.state.data, "total_yard"))} หลา</b>
                        </td>
                        <td className="text-right wpx-150">
                          <b>{baht(total(this.state.data, "amount"))} บาท</b>
                        </td>
                        <td className="text-center"></td>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
